import React from "react";
import { Link } from "react-router-dom";
const Header = ({ showHeader }) => {
  if (!showHeader) return null;

  return (
    <div className="header-container">
      <div className="header-content">
        <h1 className="header-title">
          <Link to="/home" style={{ textDecoration: "none", color: "inherit" }}>
            Lookna
          </Link>
        </h1>
        <h2 className="header-subtitle">
          FIND YOUR{" "}
          <span className="color-sp">
            IDEAL <br /> INVESTMENT
          </span>{" "}
          VAULT
        </h2>
        <p className="header-description">
          {/* Participate in exclusive investment opportunities through ICOs and
          private sales. <br/> Gain early access to promising projects and innovative
          ventures, <br/> with tailored strategies to maximize your returns */}
          Discover a range of investment options tailored to your needs, from automated solutions to customizable strategies
          {" "}
        </p>
      </div>
      <div className="details-borders"></div>
    </div>
  );
};

export default Header;
